import { render, staticRenderFns } from "./ProductInfoPeriodici.vue?vue&type=template&id=8bbadf20&scoped=true"
import script from "./ProductInfoPeriodici.vue?vue&type=script&lang=ts"
export * from "./ProductInfoPeriodici.vue?vue&type=script&lang=ts"
import style0 from "./ProductInfoPeriodici.vue?vue&type=style&index=0&id=8bbadf20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbadf20",
  null
  
)

export default component.exports